import * as numeral from 'numeral'
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'

export const setupLocalization = async () => {
    let locale = (navigator as any).userLanguage || navigator.language
    locale = locale.toLowerCase()

    // Numeral
    try {
        await import(`numeral/locales/${locale}.js`)
        numeral.locale(locale)
    } catch {}

    // Moment
    try {
        await import(`dayjs/locale/${locale}.js`)
        dayjs.locale(locale)
    } catch {}

    // dayjs
    dayjs.extend(LocalizedFormat)
}
